import React, { useEffect, useState } from "react";
import { RootState } from "../../../redux/rootReducers";
import { getAllFinacUsersAction, resetSession } from "../../../redux/auth";
import { connect } from "react-redux";
import useDebounce from "../../../customHooks/useDebounce";
import { formatDate, getCurrentMonthDates, handleDate } from "../../../utils/commonFunctions";
import {
  getUserWiseOCRReportAction,
  resetListingError,
  resetListingSuccess,
  resetUserWiseOCRReportList,
} from "../../../redux/listing";
import ORCReportHeader from "../../../components/AdminReports/OCRReport/ORCReportHeader";
import { GetAllFinacUserPayloadType } from "../../../commonTypes/authTypes";
import {
  CommonHeader,
  EmptyListPage,
  ErrorSuccessModal,
  TableLoader,
} from "../../../components/commons";
import { EmptyTimeSheetReportList } from "../../../assets/images";
import UserWiseTable from "../../../components/AdminReports/OCRReport/UserWiseTable/UserWiseTable";
import { GetUserWiseOCRReportPayloadType } from "../../../commonTypes/listing";
import {
  GetUserWiseOCRReportListType,
  InvoiceUserData,
} from "../../../redux/listing/listingTypes";

type AppProps = {
  token: string | null;

  dispatchResetSession: () => void;
  totalCount: number | null;
  userWiseOCRReportList: any[];
  dispatchGetUserWiseOCRReportAction: (
    data: GetUserWiseOCRReportPayloadType
  ) => void;
  dispatchGetAllFinacUsersAction: (data: GetAllFinacUserPayloadType) => void;
  finacUser: any;
  userFetching: boolean;
  fetching: boolean;
  error: string | null;
  dispatchResetUserWiseOCRReportAction: () => void;
  success: number | null;
  statusCode: number | null;
  dispatchResetListingErrorAction: () => void;
  dispatchResetListingSuccessAction: () => void;
};

export type DropDownUserType = {
  value: number | null;
  label: string;
};
const UserWiseOCRReport = ({
  token,
  totalCount,
  dispatchResetSession,
  userWiseOCRReportList,
  dispatchGetUserWiseOCRReportAction,
  dispatchGetAllFinacUsersAction,
  finacUser,
  userFetching,
  fetching,
  error,
  dispatchResetUserWiseOCRReportAction,
  success,
  statusCode,
  dispatchResetListingErrorAction,
  dispatchResetListingSuccessAction,
}: AppProps) => {
  const [finalUserList, setFinalUserList] = useState<DropDownUserType[] | []>(
    []
  );
  const [finalUser, setFinalUser] = useState<string>("");
  const [limit, setLimit] = useState<number>(20);
  const [data, setData] = useState<GetUserWiseOCRReportListType[] | []>([]);
  const { start, end } = getCurrentMonthDates();
  const [startDate, setStartDate] = useState<string>(start);
  const [endDate, setEndDate] = useState<string>(end);
  const [isOpen, setIsOpen] = useState(false);
  const [userOffset, setUserOffset] = useState(0);
  const [userText, setUserText] = useState("");
  const [user, setUser] = useState<any>({
    label: "All",
    value: null,
  });

  const [currentStartDate, setCurrentStartDate] = useState<string>("");
  const [currentEndDate, setCurrentEndDate] = useState<string>("");

  useEffect(() => {
    dispatchResetUserWiseOCRReportAction();
    dispatchResetListingErrorAction();
    dispatchResetListingSuccessAction();
    window.scroll({
      top: 0,
      left: 0,
    });
  }, []);

  useEffect(() => {
    if (token) {
      let finalUserData = {
        token,
        offset: userOffset,
        limit,
        user_type: "stco_users",
        status: 1,
        search_term: userText,
      };
      if (userOffset <= finacUser?.total_count) {
        dispatchGetAllFinacUsersAction?.(finalUserData);
      }
    }
  }, [userOffset]);

  useEffect(() => {
    if (userWiseOCRReportList?.length === 0) {
      setData([]);
    } else {
      setData(
        userWiseOCRReportList
          ? [
              ...userWiseOCRReportList?.map((item: InvoiceUserData) => ({
                ...item,
                isOpen,
              })),
            ]
          : []
      );
    }
  }, [userWiseOCRReportList]);

  useEffect(() => {
    const finalUserData = finacUser?.data?.map((user: any) => {
      return {
        value: user?.user_id,
        label: `${user?.first_name ? user?.first_name : ""} ${
          user?.last_name ? user?.last_name : ""
        }`,
        image: user?.profile_pic?.file_url,
      };
    });
    if (userOffset > 0) {
      setFinalUserList([...finalUserList, ...finalUserData]);
    } else {
      setFinalUserList(finalUserData);
    }
  }, [finacUser]);

  const handleExpandCollapse = (type: string) => {
    let iterableData = JSON.parse(JSON.stringify(data));

    if (type === "expand") {
      setIsOpen(true);
    }
    if (type === "collapse") {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    let iterableData = JSON.parse(JSON.stringify(data));
    if(!data || data?.length === 0) return;
    let finalData= iterableData?.map((item: any) => {
      return { ...item, isOpen };
    });
    setData([...finalData]);
  }, [isOpen]);

  const fetchNewData = (search: string) => {
    const finalData = {
      token,
      offset: userOffset,
      limit,
      user_type: "stco_users",
      status: 1,
      search_term: userText,
    };
    dispatchGetAllFinacUsersAction?.(finalData);
  };
  useDebounce(
    () => {
      if (userText) {
        fetchNewData(userText);
      } else {
        const finalData = {
          token,
          offset: userOffset,
          limit,
          user_type: "stco_users",
          status: 1,
          search_term: userText,
        };
        dispatchGetAllFinacUsersAction?.(finalData);
      }
    },
    500,
    [userText]
  );
  const handleStartDateChange = (date: string) => {
    const value = handleDate(date);
    setStartDate(value);
    setEndDate(""); 
  };

  const handleEndDateChange = (date: string) => {
    const value = handleDate(date);
    setEndDate(value);
  };
  const handleSubmitData = () => {
    let nameData = user?.label?.split("(")[0];
    setFinalUser(nameData);
    setCurrentStartDate(startDate ? formatDate(startDate) : "");
    setCurrentEndDate(endDate ? formatDate(endDate) : "");
    setIsOpen(false);
    window.scrollTo(0, 0);
    setData([]);
    if (token) {
      let finalData: GetUserWiseOCRReportPayloadType = {
        token,

        start_date: startDate ? formatDate(startDate) : "",
        end_date: endDate ? formatDate(endDate) : "",
        user_id: user?.value,
      };
      dispatchGetUserWiseOCRReportAction(finalData);
    }
  };
  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetListingErrorAction();
            }}
          />
        );
      }
    }

    return false;
  };
  return (
    <>
      <div className="row">
        <div className="col-md-6">
          <CommonHeader title="User Wise OCR Report" />
        </div>
      </div>
      <div className="col-md-12 mt-4">
        <div className="new-table-card">
          <ORCReportHeader
            startDate={startDate}
            endDate={endDate}
            handleStartDateChange={handleStartDateChange}
            handleEndDateChange={handleEndDateChange}
            handleSubmitData={handleSubmitData}
            setUserText={setUserText}
            userFetching={userFetching}
            setUserOffset={setUserOffset}
            limit={limit}
            token={token}
            currentStartDate={currentStartDate}
            currentEndDate={currentEndDate}
            user={user}
            setUser={setUser}
            finalUserList={finalUserList}
            userWiseOCRReportList={userWiseOCRReportList}
            type="User"
          />
          <div>
            <hr className="mt-1 mb-4" />

            {!!userWiseOCRReportList?.length &&
            !!currentStartDate &&
            !!currentEndDate ? (
              <div>
                <h4 className="text-center">User Wise OCR Report</h4>
                <h3 className="text-center">
                  {(finalUser === "Select..."||finalUser==="All") ? "" : finalUser}
                </h3>

                <div
                  className="pt-1"
                  style={{
                    textAlign: "center",
                    fontWeight: 600,
                    fontSize: "15px",
                    color: "#6c757d",
                  }}
                >
                  {`Start Date : ${currentStartDate} End Date: ${currentEndDate}`}
                </div>
              </div>
            ) : null}

            {!!userWiseOCRReportList?.length && (finalUser === "Select..."||finalUser==="All") ? (
              <div
                className="mr-2 mb-2"
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                  flexDirection: "row-reverse",
                }}
              >
                <div
                  className="collapse-open"
                  style={{ cursor: "pointer", color: "red" }}
                  onClick={() => handleExpandCollapse("collapse")}
                >
                  Collapse All
                </div>
                <div
                  className="collapse-open"
                  style={{ cursor: "pointer", color: "red" }}
                  onClick={() => handleExpandCollapse("expand")}
                >
                  Expand All
                </div>
              </div>
            ) : null}
          </div>

          {fetching ? (
            <TableLoader Rows={10} ColumnPerRow={7} />
          ) : data?.length > 0 ? (
            <UserWiseTable
              userWiseOCRReportList={userWiseOCRReportList}
              data={data}
              setData={setData}
              finalUser={finalUser}
            />
          ) : (
            <>
              {!fetching && (!data || data?.length === 0) && (
                <div className="pb-4 pl-0 pr-0">
                  <EmptyListPage
                    title="No User Wise OCR Report Found"
                    text={
                      !currentStartDate && !currentEndDate
                        ? "Choose User, start date and end date to get the report."
                        : ""
                    }
                    imageWidth="30%"
                    image={EmptyTimeSheetReportList}
                    showAddButton={false}
                  />
                </div>
              )}
            </>
          )}
        </div>
      </div>
      {handleErrorModal()}
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  totalCount: state.clientDirectory.totalCount,
  userWiseOCRReportList: state.listing.userWiseOCRReportList,
  finacUser: state.auth.finacUsersList,
  userFetching: state.auth.fetching,
  fetching: state.listing.fetching,
  error: state.listing.error,
  statusCode: state.listing.statusCode,
  success: state.listing.success,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),

  dispatchGetUserWiseOCRReportAction: (
    data: GetUserWiseOCRReportPayloadType
  ) => {
    dispatch(getUserWiseOCRReportAction(data));
  },
  dispatchGetAllFinacUsersAction: (data: GetAllFinacUserPayloadType) =>
    dispatch(getAllFinacUsersAction(data)),
  dispatchResetUserWiseOCRReportAction: () =>
    dispatch(resetUserWiseOCRReportList()),
  dispatchResetListingErrorAction: () => dispatch(resetListingError()),
  dispatchResetListingSuccessAction: () => dispatch(resetListingSuccess()),
});

export default connect(mapStateToProps, mapDispatchToProps)(UserWiseOCRReport);
